import { Component } from "@angular/core";
import { LegalPageComponent } from "../legal-page/legal-page.component";
import { PRIVACY_POLICIES } from "../data/privacy-policy.data";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-privacy-policy",
  imports: [LegalPageComponent],
  templateUrl: "./privacy-policy.component.html",
})
export class PrivacyPolicyComponent {
  sections = PRIVACY_POLICIES;

  appName = environment.appName

  introKey = `<p class="mb-2">ยินดีต้อนรับสู่ <span class="text-primary fw-bold">${this.appName || 'Wise'}</span>
                      ให้ความสำคัญกับการคุ้มครองข้อมูลส่วนบุคคลของลูกค้าและผู้ใช้งานแพลตฟอร์ม
                    นโยบายความเป็นส่วนตัวฉบับนี้จัดทำขึ้นเพื่ออธิบายว่าเราเก็บรวบรวม ใช้ เปิดเผย
                    และคุ้มครองข้อมูลส่วนบุคคลของลูกค้าอย่างไร
                    รวมถึงสิทธิของเจ้าของข้อมูลส่วนบุคคลตามกฎหมายที่เกี่ยวข้อง</p>`
}
